import { render, staticRenderFns } from "./ViewModalConcepto.vue?vue&type=template&id=582e5a3b&"
import script from "./ViewModalConcepto.vue?vue&type=script&lang=js&"
export * from "./ViewModalConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports